import type { ReactNode } from 'react'

export function ProseContainer({ children }: { children: ReactNode }) {
  return (
    <div
      className={
        'prose p-8 text-2xl [&_a]:!text-signup-link [&_a]:!underline [&_h1]:font-bold [&_h2]:pb-1 [&_h2]:pt-3 [&_h2]:font-bold [&_h3]:pb-1 [&_h3]:pt-3 [&_h3]:font-bold [&_p]:pb-2 [&_ul]:list-outside [&_ul]:pb-2 [&_ul]:pl-5'
      }
    >
      {children}
    </div>
  )
}
